/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Send_During_Embedding_TitleInputs */



/**
* | output |
* | --- |
* | "Files still processing" |
*
* @param {Chat_Send_During_Embedding_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_send_during_embedding_title = /** @type {((inputs?: Chat_Send_During_Embedding_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Send_During_Embedding_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien werden noch verarbeitet")
	return /** @type {LocalizedString} */ ("Files still processing")
});